import { Link } from "react-router-dom";
import { useContent, imgUrl } from "@/context/ContentContext";
import { Heart, Sparkles, Home as HomeIcon, Package, PawPrint } from "lucide-react";

const ICONS = [PawPrint, Package, Sparkles, Heart, HomeIcon];

export default function TuftBuddies() {
  const c = useContent().pages.tuft_buddies;
  return (
    <div>
      <section className="relative overflow-hidden bg-coral text-white py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="text-white/80 text-sm tracking-widest uppercase font-medium">{c.eyebrow}</div>
            <h1 className="mt-2 font-serif font-bold text-5xl md:text-7xl leading-tight">{c.heading}</h1>
            <p className="mt-6 text-white/90 text-lg max-w-lg">{c.description}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              {c.button1_label && <Link to={c.button1_link} data-testid="tb-book-btn" className="rounded-full bg-white text-coral px-8 py-4 font-semibold">{c.button1_label}</Link>}
              {c.button2_label && <Link to={c.button2_link} data-testid="tb-party-btn" className="rounded-full border-2 border-white/50 text-white px-8 py-4 font-semibold">{c.button2_label}</Link>}
            </div>
          </div>
          {c.image && <img src={imgUrl(c.image)} alt="Tuft Buddies" className="rounded-3xl h-96 w-full object-cover shadow-hover"/>}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-24">
        <h2 className="font-serif text-4xl md:text-5xl text-center font-semibold">{c.steps_heading}</h2>
        <div className="mt-12 grid md:grid-cols-5 gap-6">
          {c.steps.map((s, i) => { const Icon = ICONS[i % ICONS.length]; return (
            <div key={i} className="bg-white rounded-3xl p-6 shadow-card" data-testid={`tb-step-${i}`}>
              <div className="w-12 h-12 rounded-full bg-coral/10 grid place-items-center"><Icon size={22} className="text-coral" strokeWidth={1.5}/></div>
              <div className="step-number text-coral text-3xl mt-4">0{i+1}</div>
              <h3 className="mt-2 font-serif text-lg font-semibold">{s.title}</h3>
              <p className="mt-2 text-sm text-charcoal/70">{s.description}</p>
            </div>
          ); })}
        </div>
      </section>
    </div>
  );
}
